export default __webpack_public_path__ + "static/media/ribbin.0e1297c9.png";